import React, { useState, useEffect } from "react";
import Layout from "../common/Layout";

import buildingImage from "../assets/building.png";
// import cardImage from "../assets/featureImage.png";
import productImage1 from "../assets/productImage1.png";
import productImage2 from "../assets/productImage2.png";
import StatsSection from "../components/home/StatsSection";
import FeaturesSection from "../components/home/FeaturesSection";
import ProductsSection from "../components/home/ProductsSection";
import ProjectsSection from "../components/home/ProjectsSection";
import MobileProjectsSection from "../components/home/MobileProjectsSection";
import PartnersSection from "../components/home/PartnersSection";

import {
  
  FEATURES,
  STATS,
  PRODUCTS as PRODUCTS_CONST,
  PARTNER_LOGOS,
  PROJECTSIMPT,
} from "../data/constants";
// import PageHeader from "../common/PageHeader";
import Pioneering from "../common/Pioneering";
import { HOME_PAGE } from "../data/constants";
import PageHeaderWithLoader from "../common/PageHeaderWithLoader";
// import useWindowWidth from "../hooks/useWindowWidth";
import type { PageHeaderMedia } from "../common/PageHeaderWithLoader";

// Assign images to products
const products = PRODUCTS_CONST.map((product, idx) => ({
  ...product,
  image: idx === 0 ? productImage2 : productImage1,
  url: idx === 1 ? "/decorativeRange" : "/performanceAndSaftey",
}));

const partnerLogos = PARTNER_LOGOS;
// const HERO_VIDEO = require("../assets/hero-video.mp4"); // Place your video in assets and use this path

const Home = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 900
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const heroMedia: PageHeaderMedia = {
    type: "video",
    src: process.env.PUBLIC_URL + "/assets/hero-video.mp4",
    poster: "/assets/build.svg",
  };

  return (
    <Layout>
      <PageHeaderWithLoader
        title={HOME_PAGE.pageHeaderTitle}
        media={heroMedia}
      />
      <Pioneering />
      <StatsSection stats={STATS} />
      <FeaturesSection features={FEATURES}  />
      <ProductsSection products={products} />
      {isMobile ? (
        <MobileProjectsSection projects={PROJECTSIMPT}  />
      ) : (
        <ProjectsSection projects={PROJECTSIMPT} buildingImage={buildingImage} />
      )}
      <PartnersSection partnerLogos={partnerLogos} />
    </Layout>
  );
};

export default Home;
